module.exports = __webpack_public_path__ + "static/Taputapuatea-Regular-b0228c5025b6d64828fba515c1ea837b.ttf";